import React, { useState, useEffect } from 'react';
import './Footer.css';
import svgImage from '../../assets/imgs/1.svg';
import { trackVisitor } from '../../services/api';
import { useNavigation } from '../../contexts/NavigationContext';

const Footer = () => {
    const { navigateTo } = useNavigation();
    const [currentLang, setCurrentLang] = useState(() => {
        return localStorage.getItem('selectedLanguage') || 'KU';
    });
    const [visitorCount, setVisitorCount] = useState(0);

    useEffect(() => {
        const handleLanguageChange = (event) => {
            setCurrentLang(event.detail);
        };
        window.addEventListener('languageChange', handleLanguageChange);
        return () => window.removeEventListener('languageChange', handleLanguageChange);
    }, []);

    useEffect(() => {
        // Track visitor and get count when component mounts
        const trackAndGetCount = async () => {
            try {
                const count = await trackVisitor();
                setVisitorCount(count);
            } catch (error) {
                console.error('Error tracking visitor:', error);
            }
        };
        trackAndGetCount();
    }, []);

    const content = {
        EN: {
            about: 'About Us',
            aboutDesc: 'Reboon Organization for Education and Training',
            slogan: 'Awareness, education, innovation, service',
            quickLinks: 'Quick Links',
            home: 'Home',
            activities: 'Activities',
            publishings: 'Publishings',
            womens: 'Womens',
            contactUs: 'Contact Us',
            email: 'Email',
            phone: 'Phone',
            address: 'Address',
            followUs: 'Follow Us',
            rights: 'All rights reserved.',
            logo: 'Reboon',
            phoneNumber1: '+964 770 140 5163',
            phoneNumber2: '+964 750 140 5163',
            location: 'Sulaymaniyah, Kurdistan',
            organization: 'Reboon Organization',
            visitors: 'Number Of Visitors',
        },
        KU: {
            about: 'دەربارەی ئێمە',
            aboutDesc: 'ڕێكخراوی ڕێبوون بۆپه‌روه‌رده‌ و ڕاهێنان',
            slogan: 'هۆشیاری، پێگەیاندن، نوێگەری، خزمەت',
            quickLinks: 'بەستەرە خێراکان',
            home: 'سەرەکی',
            activities: 'چالاکیەکان',
            publishings: 'بڵاوکراوەکان',
            womens: 'خانمانی ڕۆشنگەر',
            contactUs: 'پەیوەندیمان پێوە بکە',
            email: 'ئیمەیڵ',
            phone: 'تەلەفۆن',
            address: 'ناونیشان',
            followUs: 'شوێنمان بکەوە',
            rights: 'هەموو مافێک پارێزراوە.',
            logo: 'ڕێبوون',
            phoneNumber1: '+964 770 140 5163',
            phoneNumber2: '+964 750 140 5163',
            location: 'ناونیشانی ڕێکخراوی ڕێبوون: سلێمانی-گەڕەکی مامۆستایان-نزیك مزگەوتی عوسمان ئاغا',
            organization: 'ڕێكخراوی ڕێبوون',
            visitors: 'ژمارەی سەردانیکەران',
        },
        AR: {
            about: 'من نحن',
            aboutDesc: 'منظمة ریبوون للتعليم والتدريب',
            slogan: 'الوعي، والتعليم، والابتكار، والخدمة',
            quickLinks: 'روابط سريعة',
            home: 'الرئيسية',
            activities: 'الأنشطة',
            publishings: 'المنشورات',
            womens: 'النساء',
            contactUs: 'اتصل بنا',
            email: 'البريد الإلكتروني',
            phone: 'الهاتف',
            address: 'العنوان',
            followUs: 'تابعنا',
            rights: 'جميع الحقوق محفوظة.',
            logo: 'ریبوون',
            phoneNumber1: '+964 770 140 5163',
            phoneNumber2: '+964 750 140 5163',
            location: 'السليمانية، كردستان',
            organization: 'منظمة ریبوون',
            visitors: 'عدد الزوار',
        },
        TR: {
            about: 'Hakkımızda',
            aboutDesc: 'Reboon Eğitim ve Öğretim Örgütü',
            slogan: 'Farkındalık, eğitim, yenilik, hizmet',
            quickLinks: 'Hızlı Bağlantılar',
            home: 'Ana Sayfa',
            activities: 'Etkinlikler',
            publishings: 'Yayınlar',
            womens: 'Kadınlar',
            contactUs: 'Bize Ulaşın',
            email: 'E-posta',
            phone: 'Telefon',
            address: 'Adres',
            followUs: 'Bizi Takip Edin',
            rights: 'Tüm hakları saklıdır.',
            logo: 'Reboon',
            phoneNumber1: '+964 770 140 5163',
            phoneNumber2: '+964 750 140 5163',
            location: 'Sulaymaniyah, Kurdistan',
            organization: 'Reboon Organizasyonu',
            visitors: 'Ziyaretçi Sayısı',
        },
    };

    const text = content[currentLang] || content.EN;

    return (
        <footer className="footer">
            <div className="footer-svg-background">
                <img src={svgImage} alt="" className="footer-rotating-svg" />
            </div>
            <div className="footer-wave">
                <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" className="footer-wave-path"></path>
                    <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" className="footer-wave-path"></path>
                    <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" className="footer-wave-path"></path>
                </svg>
            </div>

            <div className="footer-content">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-section">
                            <h2 className="footer-logo">{text.logo}</h2>
                            <p className="footer-description">{text.aboutDesc}</p>
                            <p className="footer-slogan">{text.slogan}</p>
                        </div>

                        <div className="footer-section">
                            <h4 className="footer-quick-links">{text.quickLinks}</h4>
                            <ul className="footer-links">
                                <li><button type="button" onClick={() => navigateTo('home')}>{text.home}</button></li>
                                <li><button type="button" onClick={() => navigateTo('activities')}>{text.activities}</button></li>
                                <li><button type="button" onClick={() => navigateTo('publishings')}>{text.publishings}</button></li>
                                <li><button type="button" onClick={() => navigateTo('womens')}>{text.womens}</button></li>
                            </ul>
                        </div>

                        <div className="footer-section">
                            <h4 className="footer-contact-us">{text.contactUs}</h4>
                            <div className="footer-contact">
                                <p>
                                    <span className="footer-icon">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                            <polyline points="22,6 12,13 2,6"></polyline>
                                        </svg>
                                    </span>
                                    reboonorg2@gmail.com
                                </p>
                                <p>
                                    <span className="footer-icon">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                        </svg>
                                    </span>
                                    <span className="phone-number" dir="ltr">{text.phoneNumber1}</span>
                                </p>
                                <p>
                                    <span className="footer-icon">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                        </svg>
                                    </span>
                                    <span className="phone-number" dir="ltr">{text.phoneNumber2}</span>
                                </p>
                                <p>
                                    <a 
                                        href="https://maps.app.goo.gl/EnpXGyNXZGs59uFs7" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                    >
                                        <span className="footer-icon">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                                <circle cx="12" cy="10" r="3"></circle>
                                            </svg>
                                        </span>
                                        {text.location}
                                    </a>
                                </p>
                            </div>
                        </div>

                        <div className="footer-section">
                            <h4 className="footer-follow-us">{text.followUs}</h4>
                            <div className="footer-social">
                                <a 
                                    href="https://www.facebook.com/people/%DA%95%DB%8E%DA%A9%D8%AE%D8%B1%D8%A7%D9%88%DB%8C-%DA%95%DB%8E%D8%A8%D9%88%D9%88%D9%86-Reboon-Org/61569535344617/?rdid=Eth6OUJgIMSaJDQF&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BvU3CSzzA%2F" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="social-link" 
                                    aria-label="Facebook"
                                >
                                    <svg viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                    </svg>
                                </a>
                                <a 
                                    href="https://t.me/ReboonOrg" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="social-link" 
                                    aria-label="Telegram"
                                >
                                    <svg viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                                    </svg>
                                </a>
                                <a 
                                    href="https://youtube.com/@reboon_organization?si=2jOLNqMVtyX0HmQp" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="social-link" 
                                    aria-label="YouTube"
                                >
                                    <svg viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                                    </svg>
                                </a>
                            </div>
                            <div className="footer-visitor-count">
                                <p>
                                    <span className="footer-visitor-label">{text.visitors}:</span>
                                    <span className="footer-visitor-number">{visitorCount.toLocaleString()}</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="footer-bottom">
                        <p>&copy; {new Date().getFullYear()} {text.organization}. {text.rights}</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
